import React, { useContext } from 'react'
import { LoadingContext } from '../M_Utils'
import { useTranslation } from 'react-i18next'

export function M_Fieldset({ label, elements, fieldColor,
    labelColor, labelInside, headerElement, height, translate }) {
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()

    fieldColor = fieldColor ? fieldColor : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    labelColor = labelColor ? labelColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    return (
        <>
            {
                labelInside ?
                    // <div style={{ padding: '5px', margin: '10px', boxShadow: `0px 0px 5px ${fieldColor ? fieldColor : "var(--color-black)"}`, borderRadius: '5px', backgroundColor: "var(--color-white)" }}>
                    <div
                        style={{
                            height: height,
                            display: height ? 'flex' : undefined,
                            flexDirection: height ? 'column' : undefined,
                            padding: '5px',
                            margin: '10px',
                            boxShadow: `1px 1px 2px ${labelColor ? labelColor : "var(--color-black)"}`,
                            border: ` 1px solid ${fieldColor ? fieldColor : "var(--color-black)"}`,
                            borderRadius: '10px', backgroundColor: "var(--color-white)"
                        }}>
                        {label || headerElement ?
                            <div style={{ display: 'grid', gridTemplateColumns: headerElement && '50% 50%' || 'auto auto', }}>
                                <h2 style={{ marginLeft: '10px', marginTop: '10px', marginRight: '10px', color: labelColor ? labelColor : "var(--color-black)" }}>{translate && t(label) || label}</h2>
                                <div style={{ margin: '10px 0px 0px 10px', display: 'flex', justifyContent: 'flex-end' }}>
                                    {headerElement}
                                </div>
                            </div>
                            : ''
                        }
                        <div style={{
                            margin: '10px',
                            ...(height ? { flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 } : {}),
                        }}>
                            {elements}
                        </div>
                    </div> :
                    <fieldset style={{ border: `1px solid ${fieldColor ? fieldColor : "var(--color-black)"}`, borderRadius: '5px', padding: '10px', margin: '10px' }}>
                        {label && <legend style={{ fontWeight: 'bold', color: labelColor ? labelColor : "var(--color-black)" }}>{translate && t(label) || label}</legend>}
                        {elements}
                    </fieldset>
            }
        </>
    )
}
